// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"48":"2e12363c","302":"d1e8aac2","315":"ca9103fc","438":"609893c3","453":"b08fc281","593":"7c9e80df"}[chunkId] + ".chunk.js";
};